import DOMPurify from 'dompurify';
import { useEffect, useMemo, useState } from 'react';

import * as systemSetting from '../../services/systemSettingsService';

export function AudioMessage({ align = 'left', showDivider = false }) {
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  // helpers
  const renderSymbols = (text = '') => {
    const hasHtml = /<\/?[a-z][\s\S]*>/i.test(text);
    if (hasHtml) return text;
    return text.replace(/</g, '&lt;').replace(/>/g, '&gt;');
  };

  const normalizeCommas = (html = '') => html.replace(/,(?!\s)/g, ', ');

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        setLoading(true);
        const msg = await systemSetting.getAudioMessageApi();
        if (alive) setMessage(msg || '');
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  const rendered = useMemo(() => {
    if (!message) return '';
    return normalizeCommas(renderSymbols(message));
  }, [message]);

  return (
    <div>
      {loading ? (
        <div>Loading..</div>
      ) : (
        !!rendered && (
          <>
            {showDivider && <div className="gray-divider" />}
            <div style={{ marginTop: 20 }}>
              <div
                className="audio-message"
                style={{ textAlign: align }}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(rendered),
                }}
              />
            </div>
          </>
        )
      )}
    </div>
  );
}
